import { Customization } from './customization';

export class AdaCustomization extends Customization {
  defaultForClient: boolean;
  defaultForLanguage: string;
  languages: string[];
  content: any[];
  contentDocuments: any;
}
